/**
 * RMA processing form — billing card: the optional billing-contact
 * selector. Hidden for quick-ship RMAs.
 *
 * Contains:
 * - BillingSection (default export)
 */

import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContactSelector } from '@sophocles/components/contacts';

import { SectionCard } from '../../components/ReturnSection';

export default function BillingSection({
  isQuickShip,
  selectedBillingContact,
  onBillingContactChange,
  customerId,
  siteGroupId,
  customer,
  siteGroup,
}) {
  const { t } = useTranslation();
  return (
    <SectionCard title={t('rma.billing', 'Billing')}>
      {!isQuickShip && (
        <Box sx={{ mb: 2 }}>
          <ContactSelector
            value={selectedBillingContact}
            onChange={onBillingContactChange}
            customerId={customerId}
            siteGroupId={siteGroupId}
            customer={customer}
            siteGroup={siteGroup}
            label={t('rma.billingContact', 'Billing Contact')}
            addressType="billing"
            required={false}
            requiredFields={['address', 'name']}
            primaryContext="rma"
            contextLabel={t('rma.rma', 'RMA')}
          />
        </Box>
      )}
    </SectionCard>
  );
}
